import React from "react"
import { View } from "react-native"
import { Horizontal, Vertical } from "@/components/standard/BFLayout"
import { H5, Small } from "@/components/standard/BFText"
import {
  type MilestoneStatus,
  MilestoneStatusMarker,
} from "./MilestoneStatusMarker"

import type { MilestoneType } from "@/generated/graphql"
import { Separator } from "@/components/reusables/ui/separator"
import { MilestoneStatusBadge } from "@/screens/loans/components/dashboard/milestones/MilestoneStatusBadge"

interface MilestoneItemProps {
  milestone: MilestoneType
  isFirstBlocked?: boolean
  isLast?: boolean
  renderSpecialContent?: () => JSX.Element
}

export const MilestoneItem: React.FC<MilestoneItemProps> = ({
  milestone,
  isLast = false,
  isFirstBlocked = false,
  renderSpecialContent,
}) => {
  const isDisabled = milestone.status === "blocked"

  return (
    <>
      <View className={`py-2 relative ${isDisabled ? "opacity-50" : ""}`}>
        <Horizontal className="gap-4 items-start">
          {/* Content */}
          <Vertical className="flex-1">
            {/* Title and Status */}
            <Horizontal className="items-center justify-between gap-4">
              <MilestoneStatusMarker
                status={milestone.status as MilestoneStatus}
                size={24}
              />

              <View className="flex-1">
                <H5 color={isDisabled ? "disabled" : "default"}>
                  {milestone.name}
                </H5>
              </View>

              {(milestone.status !== "blocked" || isFirstBlocked) && (
                <MilestoneStatusBadge milestone={milestone} />
              )}
            </Horizontal>
            <Vertical className={"pl-10 gap-2"}>
              {milestone.description && milestone.status !== "completed" && (
                <Small color={isDisabled ? "disabled" : "default"}>
                  {milestone.description}
                </Small>
              )}
              {renderSpecialContent?.()}
            </Vertical>
          </Vertical>
        </Horizontal>
      </View>
      {!isLast && (
        <View className={"py-2"}>
          <Separator />
        </View>
      )}
    </>
  )
}
